export default (value, displayLength = 28, replacer = ' ') => {
  let displayText = replacer

  if (!value) return displayText

  if (value.length > displayLength) {
    displayText = `${value.substring(0, displayLength - 1)}...`
  } else {
    displayText = value
  }

  return displayText
}